import React from "react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";

export default function XtremepushPopup() {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	return (
		<div className="popup">
			<div className="popup__card">
				<div className="popup__header">
					{t("XTREMEPUSH_POPUP.TITLE")}
				</div>
				<div className="popup__body">
					{t("XTREMEPUSH_POPUP.DESCRIPTION")}
				</div>
				<div className="popup__footer">
					<button
						className="popup__btn btn btn--med btn--primary"
						onClick={
							rootStore.xtremepushNotificationPermissionPopupStore
								.onAllow
						}
					>
						{t("XTREMEPUSH_POPUP.ALLOW_BUTTON")}
					</button>
				</div>
			</div>
		</div>
	);
}
